import React, { useEffect, useRef } from 'react';
import { assest } from '../Assest/Assest';
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';
import "../css/HomeAllContent.css"; // Import the CSS file for styling

function HomeAllContent() {
  const leftItemRef = useRef(null);
  const rightItemRef = useRef(null);
  const leftTextRef = useRef(null);
  const rightTextRef = useRef(null);
  const happyClientsRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // Use the viewport
      rootMargin: '0px',
      threshold: 0.1, // Trigger animation when 10% of the element is in view
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add the class to trigger the animation
          entry.target.classList.add('in-view');
        }
      });
    }, options);

    // Observing content items
    if (leftItemRef.current) observer.observe(leftItemRef.current);
    if (rightItemRef.current) observer.observe(rightItemRef.current);
    if (leftTextRef.current) observer.observe(leftTextRef.current);
    if (rightTextRef.current) observer.observe(rightTextRef.current);

    // Observing "Our Happy Clients" section
    if (happyClientsRef.current) observer.observe(happyClientsRef.current);

    return () => {
      // Cleanup the observer on unmount
      if (leftItemRef.current) observer.unobserve(leftItemRef.current);
      if (rightItemRef.current) observer.unobserve(rightItemRef.current);
      if (leftTextRef.current) observer.unobserve(leftTextRef.current);
      if (rightTextRef.current) observer.unobserve(rightTextRef.current);
      if (happyClientsRef.current) observer.unobserve(happyClientsRef.current);
    };
  }, []);

  const reviewSettings = {
    dots: true,  // Show dots for navigation
    infinite: true,
    speed: 500,
    slidesToShow: 3,  // Show 3 reviews per slide
    slidesToScroll: 3,  // Scroll 3 reviews at a time
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // For medium screens (tablets, etc.)
        settings: {
          slidesToShow: 2,  // Show 2 reviews per slide on medium screens
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768, // For small screens (mobile devices)
        settings: {
          slidesToShow: 1,  // Show 1 review per slide on mobile screens
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container >
      <div style={{ display: "flex", justifyContent: "center", marginTop: "30px" }}>
        <h1 style={{fontWeight:"700"}}>OUR BENEFITS</h1>
      </div>
      <div className="content-container">
        <div className="content-item left" ref={leftItemRef}>
          <img className="content-image" src={assest.Benifit} alt="Benefit 1" />
        </div>

        <div className="content-text right" ref={rightTextRef}>
          <h2 style={{fontWeight:"600"}}>"Healthy gums, healthy smile—prioritize your dental care today!"</h2>
          <div className="content-description">
            <p className="feature-title" style={{fontSize:"15px"}}>Root Canals</p>
            <p style={{ borderLeft: "1px solid black",fontSize:"15px" }}>
              Say goodbye to tooth pain with gentle root canal care. Save your natural tooth and restore its function. A healthier, pain-free smile starts here!
            </p>
          </div>
        </div>

        <div className="content-text left" ref={leftTextRef}>
          <h2 style={{fontWeight:"600"}}>"Healthy gums, healthy smile—prioritize your dental care today!"</h2>
          <div className="content-description">
            <p className="feature-title" style={{fontSize:"15px"}}>Teeth Whitening</p>
            <p style={{ borderLeft: "1px solid black",fontSize:"15px"}}>
              "Brighten your smile with professional teeth whitening! Remove stains, boost confidence, and let your smile shine like never before."
            </p>
          </div>
        </div>

        <div className="content-item right" ref={rightItemRef}>
          <img className="content-image" src={assest.Benifit1} alt="Benefit 2" />
        </div>
      </div>

      {/* "Our Happy Clients" Section */}
     {/* "Our Happy Clients" Section */}
<div ref={happyClientsRef} className="happy-clients-section">
  <div style={{ display: "flex", justifyContent: "center", marginTop: "70px" }}>
    <h1 style={{fontWeight:"600"}}>Our Happy Clients</h1>
  </div>
  <div className="happy-clients-grid">
    <img className="client-image" src={assest.client1} alt="Client 1" />
    <img className="client-image" src={assest.client2} alt="Client 2" />
    <img className="client-image" src={assest.client3} alt="Client 3" />
    <img className="client-image" src={assest.client4} alt="Client 4" />
    <img className="client-image" src={assest.client5} alt="Client 5" />
    <img className="client-image" src={assest.client6} alt="Client 6" />
  </div>
</div>


    {/* ---------------  Reviews Slider Section  ----------------- */}
    
      <div style={{ marginTop: "70px" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <h1 style={{fontWeight:"600"}}>What Our Clients Say</h1>
        </div>
        <Slider {...reviewSettings}>
          {/* Review 1 */}
          <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review1} alt="Profile 1" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"Great experience overall! Highly recommended! Visited for a routine check up and cleaning. The clinic had a good ambience. Well maintained and hygienic. Comfortable waiting area. ."</p>
            <p><strong>- Keerthi Priya Gurumurthi</strong></p>
          </div>
          {/* Review 2 */}
          <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review2} alt="Profile 2" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"The best dental experience I’ve ever had! The root canal treatment was virtually painless. Highly recommend this clinic!"</p>
            <p><strong>- Sarah Smith</strong></p>
          </div>
          {/* Review 3 */}
          <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review3} alt="Profile 3" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"I can’t stop smiling after my teeth whitening treatment! The results are amazing, and the staff made me feel so comfortable."</p>
            <p><strong>- boopathi rajagopalan</strong></p>
          </div>
          {/* Additional reviews (4 to 9) */}
          <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review4} alt="Profile 4" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"Great service, professional staff, and a clean environment. Highly recommend!"</p>
            <p><strong>- Keerthy V</strong></p>
          </div>
          {/* {Review5} */}
          <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review5} alt="Profile 1" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"I had an amazing experience with Dentin Dental Care! The staff was incredibly friendly, and my Invisalign treatment was a breeze!"</p>
            <p><strong>- Sasidharan T</strong></p>
          </div> <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review6} alt="Profile 1" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"I had an amazing experience with Dentin Dental Care! The staff was incredibly friendly, and my Invisalign treatment was a breeze!"</p>
            <p><strong>- Sabareeswari S</strong></p>
          </div> <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.review7} alt="Profile 1" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px"}}>"I had an amazing experience with Dentin Dental Care! The staff was incredibly friendly, and my Invisalign treatment was a breeze!"</p>
            <p><strong>- Pradeep Palanisamy</strong></p>
          </div> <div className="review-slide">
            <div className="review-profile">
              <img className="profile-image" src={assest.client1} alt="Profile 1" />
            </div>
            <div className="review-stars">
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
              <span className="star">&#9733;</span>
            </div>
            <p style={{fontSize:"15px" }}>"I had an amazing experience with Dentin Dental Care! The staff was incredibly friendly, and my Invisalign treatment was a breeze!"</p>
            <p><strong>- Ammu Selvan</strong></p>
          </div>
          {/* More reviews */}
          {/* Repeat the structure for remaining reviews */}
        </Slider>
      </div>
    </Container>
  );
}

export default HomeAllContent;
